"use client";
import { createContext } from "react";
export const MotionContext = /* @__PURE__ */ createContext({});
//# sourceMappingURL=index.js.map